import React, {ChangeEvent, FC} from 'react';

import {Checkbox} from '@optimaxdev/design-system';

import classNames from 'classnames';
import {connect} from 'react-redux';

import {useFeature} from 'components/feature';
import {useHasGlassesCare} from 'desktop/hooks/useHasGlassesCare/useHasGlassesCare';
import {setSaveCardChecked as setSaveCardCheckedAction} from 'desktop/pages/checkout/store/reducers/primer/primer';

import {getIsSaveCardChecked} from 'desktop/pages/checkout/store/selectors/primer/primer';

import {ApplicationStoreType} from 'desktop/store';

import s from './saveCardCheckbox.scss';

type PropsType = {
    isSaveCardChecked: boolean;
    setSaveCardChecked: (value: boolean) => void;
};

/**
 * Save card details for primer payment method
 */
export const SaveCardCheckbox: FC<PropsType> = ({isSaveCardChecked, setSaveCardChecked}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const hasGlassesCare = useHasGlassesCare();
    const onChange = (e: ChangeEvent<HTMLInputElement>) => setSaveCardChecked(e.target.checked);

    return (
        <div className={classNames(s.save, {[s.saveFacelift]: isFacelift})}>
            {!hasGlassesCare && (
                <Checkbox
                    ariaLabel="value switching"
                    isChecked={isSaveCardChecked}
                    onChange={onChange}
                    size="small"
                    value="Save details so checkout is even faster next time"
                >
                    <span className={classNames(s.label, {[s.labelFacelift]: isFacelift})}>
                        Save details so checkout is even faster next time
                    </span>
                </Checkbox>
            )}
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    isSaveCardChecked: getIsSaveCardChecked(store),
});

export const SaveCardCheckboxConnected = connect(mapStateToProps, {
    setSaveCardChecked: setSaveCardCheckedAction,
})(SaveCardCheckbox);
